<template>
  <a-card title="用户数据统计(全球)">
    <a-space >
    </a-space>
      <table class="stats-table">
        <legend>全球用户分布( 10min 后更新)</legend>
        <tr>
          <th >国家</th><th>数据</th><th>比例</th>
        </tr>
        <tr v-for="(item) in new_user_counts" :key="item.region_code">
          <td > <a :href="'http://admin.xuantu.pro/home/stats/new_user_counts?region='+item.region_code" target="_blank" >{{ item.region_name }} {{ item.region_code }}</a></td><td>{{ item.totals }}</td><td>{{ item.rate }} <div :style="{'height': '10px', 'background': '#1677ff', 'width': item.width}"></div></td>
        </tr>
        
      </table>
      <hr />
  </a-card>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
// import { SearchOutlined } from '@ant-design/icons-vue';
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    // UserEditor,
    // SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      new_user_counts: [],
      loading: false,
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      const rsp = await request.get('/api/stats/new_user/regions', {})
      this.loading = false
      this.new_user_counts = rsp.data.result
      let totals = 0
      for(let i = 0; i < this.new_user_counts.length; i++){
        totals += this.new_user_counts[i].totals
      }
      for(let i = 0; i < this.new_user_counts.length; i++){
        let width  = (this.new_user_counts[i].totals / totals * 100).toFixed(2) 
        this.new_user_counts[i].rate = width + '%'
        this.new_user_counts[i].width = width * 3 + 'px'
      }
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #999;
  padding: 4px 8px;
}
</style>